import { PickerDateTimeFormat } from "./types";
import { Region } from "common/regions";
import { userPreferencesDefaults as settingsDefault } from "common/user-preferences-defaults";
import { useGetUserPreferences } from "hooks/use-get-user-preferences";
export const useGlobalization = () => {
    const [userPreferences] = useGetUserPreferences();
    const format = Object.values(PickerDateTimeFormat)
        .find((f) => f === (userPreferences?.dateFormat ?? settingsDefault.dateFormat).toString());
    const region = Object.values(Region)
        .find((r) => r === (userPreferences?.region ?? settingsDefault.region));
    return { format, region };
};
